import React from 'react'
import { UploadInformation } from './uploadInformation/uploadInformation'
import { UploadProcess } from './uploadProcess/uploadProcess'
import { UploadHeader } from "../components/uploadHeader";
import './myProfileUploadDocumentation.scss'
import { UPLOAD_DOCUMENTATION } from "constants/tagging";
import { recordPage } from "utilities/tagging";

export class MyProfileUploadDocumentation extends React.Component {
    constructor() {
        super();
    }

    componentDidMount() {
        recordPage({
            nombrePagina: UPLOAD_DOCUMENTATION
        })
    }

    render() {
        return (
            <React.Fragment>
                <UploadHeader />
                <div className="upload-documentation-container grid-view__body">
                    <div className="col-xs-12 col-md-8">
                        <UploadProcess />
                    </div>
                    <div className=" col-xs-12 col-md-4">
                        <UploadInformation />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
